<div class="progress-div" *ngIf="metaData.inProgress" [ngStyle]="getProgressBarStyle()">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="table-container">

  <!-- without expand and collapse row when click on row -->
  <ng-container *ngIf="!metaData['isRowCollapseExpand']">
    <table mat-table [dataSource]="tableDataSource" style="position: relative;">

      <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index" matColumnDef="{{disCol}}">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="getHeaderStyle(colIndex)" class="hsl-shared-table-header">
          <span class="px-sub-heading"
            *ngIf="!metaData[disCol] || (metaData[disCol] && !metaData[disCol]['hideTitleText'])">
            <span *ngIf="metaData[disCol] && metaData[disCol]['sortable']" class="icon"
              (click)="metaData[disCol] && metaData[disCol].callbackFn ? handleSortableIconClick() : $event.preventDefault()">
              <img
                [ngClass]="{'up-arrow': metaData[disCol].currentDirectionOfStatus === 'asc', 'down-arrow': metaData[disCol].currentDirectionOfStatus === 'desc'}"
                src="assets/images/arrow_upward.svg" />
            </span>
            {{metaData[disCol] && metaData[disCol]['hideColumnName'] ? '' : getCapitalizedValue(disCol)}}
          </span>
        </th>

        <td mat-cell *matCellDef=" let element">
          <ng-container *ngIf="(metaData[disCol] && !metaData[disCol]['hideValue']) || !metaData[disCol]">
            <ng-container *ngIf="disCol === 'status' && metaData[disCol] && metaData[disCol]['icon']">
              <div class="d-inline-block align-middle status mr-1 {{element[disCol]}}"></div>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['menu_icon']">
              <button class="rounded-icon-button more-vert-icon" style="float:left"
                [ngClass]="{'show-on-hover': metaData[disCol]['menu_icon']['showOnHover']}"
                (click)="metaData[disCol]['menu_icon'].callbackFn && metaData[disCol]['menu_icon'].callbackFn(element, i); $event.stopPropagation();"
                [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" class="menu-open">

                <span *ngIf="isNudgeJourney">
                  <button mat-menu-item
                    (click)="metaData[disCol]['analytics_icon'].callbackFn && metaData[disCol]['analytics_icon'].callbackFn(element, i); $event.stopPropagation();">
                    <span>Reports</span>
                    <ng-container *ngIf="metaData[disCol] && metaData[disCol]['analytics_icon']">
                      <span class="rounded-icon-button"
                        [ngClass]="{'show-on-hover': metaData[disCol]['analytics_icon']['showOnHover']}"
                        (click)="metaData[disCol]['analytics_icon'].callbackFn && metaData[disCol]['analytics_icon'].callbackFn(element, i); $event.stopPropagation();">
                        <mat-icon class="analytics-chart-icon">show_chart</mat-icon>
                      </span>
                    </ng-container>
                  </button>
                </span>

                <span *ngIf="isNudgeJourney && !element['smt_jid']">
                  <button mat-menu-item
                    (click)="metaData[disCol]['duplicate_icon'].callbackFn && metaData[disCol]['duplicate_icon'].callbackFn(element); $event.stopPropagation();">
                    <span>Duplicate</span>
                    <ng-container *ngIf="metaData[disCol] && metaData[disCol]['duplicate_icon']">
                      <span class="rounded-icon-button"
                        [ngClass]="{'show-on-hover': metaData[disCol]['duplicate_icon']['showOnHover']}"
                        (click)="metaData[disCol]['duplicate_icon'].callbackFn && metaData[disCol]['duplicate_icon'].callbackFn(element); $event.stopPropagation();">
                        <span class="material-icons duplicate-icon">
                          content_copy
                        </span>
                      </span>
                    </ng-container>
                  </button>
                </span>

                <span *ngIf="isNudgeJourney && !element['smt_jid']">
                  <button mat-menu-item
                    (click)="metaData[disCol]['edit_icon'].callbackFn && metaData[disCol]['edit_icon'].callbackFn(element); $event.stopPropagation();">
                    <span>Edit</span>
                    <ng-container *ngIf="metaData[disCol] && metaData[disCol]['edit_icon']">
                      <span class="rounded-icon-button"
                        [ngClass]="{'show-on-hover': metaData[disCol]['edit_icon']['showOnHover']}"
                        (click)="metaData[disCol]['edit_icon'].callbackFn && metaData[disCol]['edit_icon'].callbackFn(element); $event.stopPropagation();">
                        <span class="material-icons edit-icon">
                          edit
                        </span>
                      </span>
                    </ng-container>
                  </button>
                </span>

                <button mat-menu-item *ngIf="!element['smt_jid']"
                  (click)="metaData[disCol]['delete_icon'].callbackFn && metaData[disCol]['delete_icon'].callbackFn(element); $event.stopPropagation();">
                  <span style="margin-right: 23px;">Delete</span> &nbsp;&nbsp;&nbsp;
                  <ng-container
                    *ngIf="metaData[disCol] && metaData[disCol]['delete_icon'] && metaData['isJourneyListPage']">
                    <ng-container
                      *ngTemplateOutlet="JourneyDeleteIconBtn; context: {metaData: metaData, disCol: disCol, element: element}">
                    </ng-container>
                  </ng-container>

                </button>
              </mat-menu>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['isLink']">
              <span [ngClass]="{'link': element['inactivated_user'], 'link-btn': element['inactivated_user']}"
                (click)="metaData[disCol] && metaData[disCol].linkCallbackFn ? metaData[disCol].linkCallbackFn(element) : $event.preventDefault();">
                {{metaData[disCol] && metaData[disCol]['capitalize'] ? getCapitalizedValue(element[disCol]) : element[disCol]}}
              </span>
            </ng-container>

            <ng-container *ngIf="(metaData[disCol] && !metaData[disCol]['isLink']) || !metaData[disCol]">
              <ng-container *ngIf="metaData[disCol] && metaData[disCol]['capitalize']">
                {{getCapitalizedValue(element[disCol])}}
              </ng-container>
              <ng-container *ngIf="disCol === 'email' && metaData['isUserListPage']">
                <span class="copy-email" (click)="copyLink(element.email)">
                  {{element['email']}}
                </span>
              </ng-container>
              <ng-container
                *ngIf="!(metaData[disCol] && metaData[disCol]['capitalize']) && !(disCol === 'email' && metaData['isUserListPage'])">
                {{element[disCol]}}
              </ng-container>
              <div class="px-sub-text2 text-capitalize desc" *ngIf="metaData['actionTab'] && colIndex === 2">
                Last edited: {{ element['updated_at']}}
              </div>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['hasDescription']">
              <div class="px-sub-text2 text-capitalize">
                {{element['desc']}}
              </div>
            </ng-container>

            <ng-container
              *ngIf="metaData[disCol] && metaData[disCol]['delete_icon'] && metaData['isUserListPage'] && element['shouldShowDeleteIcon']">
              <ng-container
                *ngTemplateOutlet="deleteIconBtn; context:{metaData: metaData, disCol: disCol, element: element}">
              </ng-container>
            </ng-container>

            <ng-container *ngIf="disCol === 'journey' && metaData['isJourneyListPage']">
              <div class="status-container {{element['status']}}">
                {{ element['status'] }}
              </div>
            </ng-container>

          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
        (click)="metaData.rowCallbackFn ? metaData.rowCallbackFn(row) : $event.preventDefault()"
        [ngClass]="{'pointer': metaData.isRowClickable}" [class.expandable-row]="expandedElement === row">
      </tr>
    </table>
  </ng-container>

  <!-- with expand and collapse row when click on row -->

  <ng-container *ngIf="metaData['isRowCollapseExpand']">
    <table mat-table [dataSource]="tableDataSource" multiTemplateDataRows style="position: relative;">
      <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index" matColumnDef="{{disCol}}">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="getHeaderStyle(colIndex)" class="hsl-shared-table-header">
          <span class="px-sub-heading"
            *ngIf="!metaData[disCol] || (metaData[disCol] && !metaData[disCol]['hideTitleText'])">
            <span *ngIf="metaData[disCol] && metaData[disCol]['sortable']" class="icon"
              (click)="metaData[disCol] && metaData[disCol].callbackFn ? handleSortableIconClick() : $event.preventDefault()">
              <img
                [ngClass]="{'up-arrow': metaData[disCol].currentDirectionOfStatus === 'asc', 'down-arrow': metaData[disCol].currentDirectionOfStatus === 'desc'}"
                src="assets/images/arrow_upward.svg" />
            </span>
            {{metaData[disCol] && metaData[disCol]['hideColumnName'] ? '' : getCapitalizedValue(disCol)}}
          </span>
        </th>

        <td mat-cell *matCellDef=" let element">
          <ng-container *ngIf="(metaData[disCol] && !metaData[disCol]['hideValue']) || !metaData[disCol]">
            <ng-container *ngIf="disCol === 'status' && metaData[disCol] && metaData[disCol]['icon']">
              <div class="d-inline-block align-middle status mr-1 {{element[disCol]}}"></div>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['isLink']">
              <span [ngClass]="{'link': element['inactivated_user'], 'link-btn': element['inactivated_user']}"
                (click)="metaData[disCol] && metaData[disCol].linkCallbackFn ? metaData[disCol].linkCallbackFn(element) : $event.preventDefault();">
                {{metaData[disCol] && metaData[disCol]['capitalize'] ? getCapitalizedValue(element[disCol]) :
                element[disCol]}}
              </span>
            </ng-container>

            <ng-container *ngIf="(metaData[disCol] && !metaData[disCol]['isLink']) || !metaData[disCol]">
              <ng-container *ngIf="metaData[disCol] && metaData[disCol]['capitalize']">
                {{getCapitalizedValue(element[disCol])}}
              </ng-container>
              <ng-container *ngIf="disCol === 'email' && metaData['isActivityLogsPage']">
                <span class="copy-email" (click)="copyLink(element.email)">
                  {{element['email']}}
                </span>
              </ng-container>
              <ng-container
                *ngIf="!(metaData[disCol] && metaData[disCol]['capitalize']) && !(disCol === 'email' && metaData['isActivityLogsPage'])">
                {{element[disCol]}}
              </ng-container>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['hasDescription']">
              <div class="px-sub-text2 text-capitalize">
                {{element['desc']}}
              </div>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['delete_icon'] && !metaData['isUserListPage']">
              <ng-container
                *ngTemplateOutlet="deleteIconBtn; context: {metaData: metaData, disCol: disCol, element: element}">
              </ng-container>
            </ng-container>

            <ng-container
              *ngIf="metaData[disCol] && metaData[disCol]['delete_icon'] && metaData['isUserListPage'] && element['shouldShowDeleteIcon']">
              <ng-container
                *ngTemplateOutlet="deleteIconBtn; context:{metaData: metaData, disCol: disCol, element: element}">
              </ng-container>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['analytics_icon']">
              <button class="rounded-icon-button"
                [ngClass]="{'show-on-hover': metaData[disCol]['analytics_icon']['showOnHover']}"
                (click)="metaData[disCol]['analytics_icon'].callbackFn && metaData[disCol]['analytics_icon'].callbackFn(element, i); $event.stopPropagation();"
                matTooltip="Reports" [matTooltipPosition]="'above'" matTooltipClass="above">
                <mat-icon class="analytics-chart-icon">show_chart</mat-icon>
              </button>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['duplicate_icon']">
              <button class="rounded-icon-button"
                [ngClass]="{'show-on-hover': metaData[disCol]['duplicate_icon']['showOnHover']}"
                (click)="metaData[disCol]['duplicate_icon'].callbackFn && metaData[disCol]['duplicate_icon'].callbackFn(element); $event.stopPropagation();"
                matTooltip="Duplicate Journey" [matTooltipPosition]="'above'" matTooltipClass="above">
                <span class="material-icons duplicate-icon">
                  content_copy
                </span>
              </button>
            </ng-container>

            <ng-container *ngIf="disCol === 'journey' && metaData['isJourneyListPage']">
              <div class="status-container {{element['status']}}">
                {{ element['status'] }}
              </div>
            </ng-container>

            <ng-container *ngIf="metaData[disCol] && metaData[disCol]['arrow_icon']">
              <span class="toggle-icon" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                <img *ngIf="element !== expandedElement" src="assets/images/vector_arrow_down.svg#arrowDownIcon" alt="">
                <img *ngIf="element === expandedElement" class="vector-arrow-up"
                  src="assets/images/vector_arrow_up.svg#arrowUpIcon" alt="">
              </span>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div class="example-element-detail"
              [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
              <div class="example-detail-cont d-flex">
                <div class="meta-text">
                  Metadata : {{splitText(element.meta)}}
                  <!-- Metadata : <pre>{{getFormatedData(element.meta)}}</pre> -->
                </div>
                <div class="copy-icon" (click)="copyClipBoard(element.meta)">
                  <div class="copy-img">
                    <img height="20" width="20" src="/assets/images/copy_paste.svg">
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr mat-row class="logs" *matRowDef="let row; columns: displayedColumns; let i = index"
        (click)="metaData.rowCallbackFn ? metaData.rowCallbackFn(row) : $event.preventDefault();expandedElement = expandedElement === row ? null : row"
        [ngClass]="{'pointer': metaData.isRowClickable}" [class.expandable-row]="expandedElement === row">
      </tr>
      <ng-container>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </ng-container>


    </table>
  </ng-container>

  <div class="min-w-100" *ngIf="metaData.paginator && metaData.paginator.showPaginator">
    <mat-paginator [length]="metaData.paginator.length" [pageSize]="metaData.paginator.pageSize" class="paginator"
      [pageSizeOptions]="metaData.paginator.pageSizeOptions" (page)="handlePageChange($event)" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

<ng-template #deleteIconBtn let-metaData="metaData" let-disCol="disCol" let-element="element">
  <button class="rounded-icon-button"
    [ngClass]="{'show-on-hover': metaData[disCol] && metaData[disCol]['delete_icon']['showOnHover']}" appDisableFeature
    [pathString]="metaData[disCol]['delete_icon'] && metaData[disCol]['delete_icon']['pathString']"
    (click)="metaData[disCol]['delete_icon'] && metaData[disCol]['delete_icon'].callbackFn(element, i); $event.stopPropagation();"
    matTooltip="Delete" [matTooltipPosition]="'above'">
    <span class="material-icons">
      delete
    </span>
  </button>
</ng-template>

<ng-template #JourneyDeleteIconBtn let-metaData="metaData" let-disCol="disCol" let-element="element">
  <button class="rounded-icon-button" [ngClass]="{'show-on-hover':  metaData[disCol]['delete_icon']['showOnHover']}"
    appDisableFeature [pathString]="metaData[disCol]['delete_icon'] && metaData[disCol]['delete_icon']['pathString']"
    (click)="metaData[disCol]['delete_icon'] && metaData[disCol]['delete_icon'].callbackFn(element, i); $event.stopPropagation();">
    <span class="material-icons delete-icon">
      delete
    </span>
  </button>
</ng-template>
